<template>
  <div uk-grid>
      <Sidebar />
    <transition name="left" appear>
      <SingleContent />
    </transition>

  </div>
</template>


<script>
// @ is an alias to /src
import Sidebar from '@/components/Sidebar.vue'
import SingleContent from '@/components/SingleContent.vue'

export default {
  name: 'Single',
  components: {
    Sidebar,
    SingleContent,
  },
}
</script>

<style>
.left-enter-active {
  animation: left 1s;
}

.scale-leave-active {
}

@keyframes left {
  from {
    opacity: 0;
    transform: translate(-200px,0);
  }
  to {
    opacity: 1;
    transform: translate(0,0);
  }
}
</style>

